import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TypeStructure } from 'src/app/shared/models/typeStructure';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class TypeStructureService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllTypeStructure(): Observable<TypeStructure[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeStructureUrl}/all`,
			'getAllTypeStructure'
		);
	}

	importTypeStructure(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'typeStructure.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeStructureUrl}/import`,
			`importTypeStructure`,
			formData
		);
	}

	getTypeStructureById(id: number): Observable<TypeStructure> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.typeStructureUrl}/get/${id}`,
			'getTypeStructureById'
		);
	}

	updateTypeStructure(typeStructure: TypeStructure): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.typeStructureUrl}/update/${typeStructure.id}`,
			'updateTypeStructure',
			typeStructure
		);
	}

	addTypeStructure(typeStructure: TypeStructure): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.typeStructureUrl}/add`,
			'addTypeStructure',
			typeStructure
		);
	}

	deleteTypeStructure(typeStructureId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.typeStructureUrl}/delete/${typeStructureId}`,
			`deleteTypeStructure`
		);
	}
}
